// removed by extract-text-webpack-plugin
module.exports = {"Category":"_1mdAATOlrgDQmEpLr2EmQP","Icon":"_1UxKRWH4N-plqHoGS7tSEG","Cell":"Amj7ptQFzwZQwKWWAGGyX","Root":"_3X93Tk17yig9n8X6OeMFMG","Back":"_1j5fx6E-9boTEK1tlyU5yW","Open":"_2nqbpeSSeitSE3_AGhyvgF","Close":"_1RfG7XMdv3zOdROW4wDdZ2","Second":"tEMIvnncnksOoWBC-YFfM","ListItem":"_1ZCp5VLzObaYsMtiy_czv8","List":"_7nBUl6JrcbxoeHJ2TVIgr","Chosen":"_2xFiAM4L-yLYSHMJRE7o8b"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Categories/Category/Category.css
// module id = 245
// module chunks = 0